import { SubmitHandler, useForm } from "react-hook-form";
import { Col, Form, Input, Label, Row } from "reactstrap";
import { Btn } from "../../AbstractElements";
import { Cancel, Save, SubTask, TaskTitle } from "../../Constant";
import { useAppDispatch, useAppSelector } from "../../Redux-Toolkit/Hooks";
import { addNewTask, setAddModal, setMyTask, setValidation } from "../../Redux-Toolkit/Reducers/TaskSlice";
import { AddtaskData } from "../../Type/TaskType";
import { TaskRadioRow } from "./TaskRadioRow";

export const NewTaskModalForm = () => {
  const { register, handleSubmit, formState: { errors }, reset } = useForm();
  const { validation } = useAppSelector((state) => state.task);
  const dispatch = useAppDispatch();

  const Addtask: SubmitHandler<AddtaskData> = (data) => {
    if (data.title !== "" && data.collection !== "" && data.description !== "") {
      dispatch(addNewTask(data));
      dispatch(setMyTask(data));
      dispatch(setAddModal());
      reset();
    }
  };

  return (
    <Form className="form-bookmark needs-validation" onSubmit={handleSubmit(Addtask)}>
      <Row>
        <Col md="12" className="mb-3 mt-0">
          <Label check>{TaskTitle}</Label>
          <input type="text" className={`form-control ${validation && `${errors.title ? "is-invalid" : "is-valid"}`}`} {...register("title", {required: true,})} />
        </Col>
        <Col md="12" className="mb-3 mt-0">
          <Label check>{SubTask}</Label>
          <Input type="text" className="form-control" />
        </Col>
        <TaskRadioRow />
        <Col md="6" className="mb-3 mt-0">
          <Input type="select" className="js-example-basic-single">
            <option value="My Task">My Task</option>
          </Input>
        </Col>
        <Col md="6" className="mb-3 mt-0">
          <select className={`js-example-disabled-results form-select ${validation && `${errors.collections ? "is-invalid" : "is-valid"}`}`} {...register("collection", {required: true,})}>
            <option value="General">General</option>
          </select>
        </Col>
        <Col md="12" className="mb-3 col-md-12 my-0">
          <textarea className={`form-control ${validation && `${errors.description ? "is-invalid" : "is-valid"}`}`} {...register("description", {required: true,})} />
        </Col>
      </Row>
      <Btn color="secondary" className="me-1" type="submit" onClick={() => dispatch(setValidation(true))}>{Save}</Btn>
      <Btn color="primary" onClick={() => dispatch(setAddModal())}>{Cancel}</Btn>
    </Form>
  );
};
